import React, { useEffect } from 'react'
import logo from "../assets/images/vodafone-business-logo.png"
import vodafonebusinesslogolast from "../assets/images/vodafone-business-logo-last.png"
import Redlogo from "../assets/images/vodafone-business-logo-red.png"
import banner_1 from "../assets/images/report/image-bg.jpg";
import banner_2 from "../assets/images/report/image-bg-2.png";
import banner_3 from "../assets/images/report/image-bg-3.png";
import banner_4 from "../assets/images/report/image-bg-4.png";
import methodologyimg from "../assets/images/report/methodology-img.jpg";
import methodologyimg2 from "../assets/images/report/methodology-img-2.jpg";
import businessimage from "../assets/images/report/business-image.jpg";
import peopleimage from "../assets/images/report/people-image.jpg";
import operatingmodelimage from "../assets/images/report/operating-model-image.jpg";
import infraimage from "../assets/images/report/infra-image.jpg";
import networkimage from "../assets/images/report/network-image.jpg";
import securityimage from "../assets/images/report/security-image.jpg";
import vodafoneimage5 from "../assets/images/report/vodafone-image-5.jpg";

import businessicon from "../assets/images/report/business-icon.png";
import businessiconwhite from "../assets/images/report/business-icon-white.png";
import peopleicon from "../assets/images/report/people-icon.png";
import peopleiconwhite from "../assets/images/report/people-icon-white.png";
import operatingmodelicon from "../assets/images/report/operating-model-icon.png";
import operatingmodeliconwhite from "../assets/images/report/operating-model-icon-white.png";
import infraicon from "../assets/images/report/infra-icon.png";
import infraiconwhite from "../assets/images/report/infra-icon-white.png";
import networkicon from "../assets/images/report/network-icon.png";
import networkiconwhite from "../assets/images/report/network-icon-white.png";
import securityicon from "../assets/images/report/security-icon.png";
import securityiconwhite from "../assets/images/report/security-icon-white.png";
import chart from "../assets/images/report/chart.png";

import iconlist1 from "../assets/images/report/icon-list-1.png";
import iconlist2 from "../assets/images/report/icon-list-2.png";

import ContentCounter from "../assets/images/report/content-counter-bg.png";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSurveyReport } from '../store/actions/surveyFormAction';

export default function Report() {

    //States
    const { survey_id } = useParams();
    const ss_id = localStorage.getItem('customer_ss_id')

    const dispatch = useDispatch()
    const surveyReportData = useSelector((state) => state.surveyData?.surveyReport)


    //Effects
    useEffect(() => {
        const payload = {
            survey_id,
            srid: "1",
            ss_id
        }
        dispatch(getSurveyReport(payload))
    }, [])


    return (
        <>
            <div className="page-wrapper">
                <div className="banner-wrapper section-height" style={{ backgroundImage: 'url(' + banner_1 + ')' }}>

                    <div className="report-container">
                        <div className="text-inner">
                            <div className="text-wrap">
                                <h1>Vodafone Business</h1>
                                <h4>Rapid Cloud Assessment</h4>
                                <p>
                                    &lt;ENTER NAME&gt; your company &lt; ENTER YOUR COMPANY NAME&gt; is at an ‘&lt; ENTER MATURITY STAGE&gt;’
                                    stage
                                </p>
                            </div>
                            <div className="vodafone-logo">
                                <img src={logo} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-wrapper section-height banner-2" style={{ backgroundImage: 'url(' + banner_2 + ')' }}>
                    <div className="report-container">
                        <div className="text-inner">
                            <div className="text-wrap">
                                <h1>Vodafone Business</h1>
                                <h4>Rapid Cloud Assessment</h4>
                                <p>
                                    &lt; ENTER NAME&gt; your company &lt; ENTER YOUR COMPANY NAME&gt; is at an ‘&lt; ENTER MATURITY STAGE&gt;’
                                    stage
                                </p>
                            </div>
                            <div className="vodafone-logo">
                                <img src={logo} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-wrapper section-height" style={{ backgroundImage: 'url(' + banner_3 + ')' }}>
                    <div className="report-container">
                        <div className="text-inner">
                            <div className="text-wrap">
                                <h1>Vodafone Business</h1>
                                <h4>Rapid Cloud Assessment</h4>
                                <p>
                                    &lt; ENTER NAME&gt; your company &lt; ENTER YOUR COMPANY NAME&gt; is at an ‘&lt; ENTER MATURITY STAGE&gt;’
                                    stage
                                </p>
                            </div>
                            <div className="vodafone-logo">
                                <img src={logo} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-wrapper section-height" style={{ backgroundImage: 'url(' + banner_4 + ')' }}>
                    <div className="report-container">
                        <div className="text-inner">
                            <div className="text-wrap">
                                <h1>Vodafone Business</h1>
                                <h4>Rapid Cloud Assessment</h4>
                                <p>
                                    &lt; ENTER NAME&gt; your company &lt; ENTER YOUR COMPANY NAME&gt; is at an ‘&lt; ENTER MATURITY STAGE&gt;’
                                    stage
                                </p>
                            </div>
                            <div className="vodafone-logo">
                                <img src={logo} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-counter section-height" style={{ backgroundImage: 'url(' + ContentCounter + ')' }}>
                    <div className="report-container">
                        <div className="text-inner position-relative">
                            <div className="heading">
                                <h2>Content</h2>
                            </div>
                            <div className="list-items-wrapper">
                                <ul className="list-items">
                                    <li>
                                        <div className="count">01</div>
                                        <p>Introduction</p>
                                    </li>
                                    <li>
                                        <div className="count">02</div>
                                        <p>Methodology</p>
                                    </li>
                                    <li>
                                        <div className="count">03</div>
                                        <p>
                                            &lt; Enter Company&gt; Cloud Assessment
                                        </p>
                                    </li>
                                    <li>
                                        <div className="count">04</div>
                                        <p>Assessment questions</p>
                                    </li>
                                    <li>
                                        <div className="count">05</div>
                                        <p>Vodafone Business Cloud Services</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="vodafone-logo">
                                <img src={logo} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-1 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title"><span>01</span>Introduction</div>
                                <div className="text-wrapper">
                                    <div className="txt-top">
                                        <p>Thank you for taking Vodafone Business Cloud Readiness assessment. We have evaluated
                                            your
                                            organisations business goals, people, operating model, infrastructure, network, and
                                            security based on your responses, and we are pleased to present you with a Vodafone
                                            Business Rapid Clous Assessment Readiness report.</p>
                                    </div>
                                    <div className="txt-main">
                                        <h5>The Report</h5>
                                        <p>Within this report you will find a comprehensive summary of our assessment, including
                                            scores for each assessment question and a detailed analysis of your organisation's
                                            readiness in each key area.
                                            We have also provided recommendations on how to address any gaps in readiness and
                                            how to
                                            optimise your organisations cloud adoption and transformation.</p>
                                    </div>
                                    <div className="txt-main">
                                        <h5>Vodafone Business</h5>
                                        <p>As a trusted partner in cloud and digital transformation, Vodafone Business is
                                            committed
                                            to supporting your organisation's cloud journey.
                                            In addition to the assessment report, we have included information on our services
                                            and
                                            solutions that can help address any gaps in readiness, including infrastructure,
                                            security, and network, as well as ongoing management and optimisation of your cloud
                                            environment.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="table-wrap section-padding-right">
                            <div className="right-inner">
                                <div className="table-wrapper">
                                    <div className="tablle-inner">
                                        <table className="custom-table">
                                            <tbody>
                                                <tr>
                                                    <th />
                                                    <th>Question 1</th>
                                                    <th>Question 2</th>
                                                    <th>Question 3</th>
                                                    <th>Question 4</th>
                                                    <th>Question 5</th>
                                                    <th>Score</th>
                                                </tr>
                                                <tr>
                                                    <td>Business</td>
                                                    <td>2</td>
                                                    <td>2</td>
                                                    <td>2</td>
                                                    <td>2</td>
                                                    <td>2</td>
                                                    <td>72%</td>
                                                </tr>
                                                <tr>
                                                    <td>People</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>72%</td>
                                                </tr>
                                                <tr>
                                                    <td>Operating Model</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>72%</td>
                                                </tr>
                                                <tr>
                                                    <td>Infrastructure</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>72%</td>
                                                </tr>
                                                <tr>
                                                    <td>Network</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>72%</td>
                                                </tr>
                                                <tr>
                                                    <td>Security</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>x.x</td>
                                                    <td>72%</td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                        
                                        <div className="table-footer">
                                            <h4>Overall Score</h4>
                                            <p>59%</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="desclaimer-text">
                                    <h5>Disclaimer</h5>
                                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                                        tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam,
                                        quis
                                        nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                                        consequat.
                                        Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat,
                                        vel
                                        illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim
                                        qui
                                        blandit praesent luptatum zzril delenit augue duis dolore</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li className="active">
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li>
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={Redlogo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-2 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title"><span>02</span>Methodology</div>
                                <div className="text-wrapper">
                                    <div className="txt-main txt-big">
                                        <h5>Lead Indicators</h5>
                                        <p>Vodafone Business Rapid Cloud Assessment lead indicators are key areas that
                                            organisations need to assess and address when planning a move to the cloud. By
                                            understanding their current level of readiness in each of these areas, organisations
                                            can identify gaps and develop a comprehensive plan to successfully migrate to a
                                            cloud-based environment.</p>
                                    </div>
                                    <div className="icon-text-list">
                                        <ul>
                                            <li>
                                                <div className="icon">
                                                    <img src={businessicon} />
                                                </div>
                                                <div className="text">
                                                    <h5>Business</h5>
                                                    <p>The "Business" indicator refers to overall business strategy, goals, and
                                                        objectives, and how they relate to cloud adoption. This indicator
                                                        involves assessing an organisations readiness to adopt new technologies,
                                                        their willingness to invest in cloud infrastructure, and their
                                                        understanding of the benefits and risks of cloud migration</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={peopleicon} />
                                                </div>
                                                <div className="text">
                                                    <h5>People</h5>
                                                    <p>The "people" indicator refers to human resources and talent, and how they
                                                        relate to cloud adoption. This indicator involves assessing an
                                                        organisation's workforce and their skIlls and experience with cloud
                                                        technology, as well as their ability to adapt to new ways of working and
                                                        new cloud-based tools and systems.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={operatingmodelicon} />
                                                </div>
                                                <div className="text">
                                                    <h5>Operating Model</h5>
                                                    <p>The "operating model" indicator refers to an organisation's existing IT
                                                        operating model, and how it will need to change to accommodate cloud
                                                        adoption. This indicator involves assessing the current IT processes,
                                                        governance, and workflows, and identifying areas that will need to be
                                                        modified or replaced to support a cloud-based environment.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={infraicon} />
                                                </div>
                                                <div className="text">
                                                    <h5>Infrastructure</h5>
                                                    <p>The "infrastructure" indicator refers to an organisation's existing IT
                                                        infrastructure, including hardware, software, and data storage systems,
                                                        and how they will need to change to accommodate cloud adoption. This
                                                        indicator involves assessing the current I intrastructure and
                                                        identifying which systems will need to be migrated to the cloud, which
                                                        will need to be replaced, and which can be integrated into a hybrid
                                                        cloud environment.
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={networkicon} />
                                                </div>
                                                <div className="text">
                                                    <h5>Network</h5>
                                                    <p>The "network" indicator refers to the existing network infrastructure,
                                                        including routers, switches, and firewalls, and how they will need to
                                                        change to accommodate cloud adoption. This indicator involves assessing
                                                        the organisation's current network infrastructure and identifying which
                                                        systems will need to be modified or replaced to support a cloud-based
                                                        environment, as well as any security protocols that will need to be put
                                                        in place.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={securityicon} />
                                                </div>
                                                <div className="text">
                                                    <h5>Security</h5>
                                                    <p>The "security" indicator refers to an organisation's existing security
                                                        protocols and practices, and how they will need to change to accommodate
                                                        cloud adoption. This indicator involves assessing the current security
                                                        practices and identifying any gaps or vulnerabilities that will need to
                                                        be addressed when moving to a cloud-based environment. It also involves
                                                        ensuring that appropriate security controls are ir place to protect data
                                                        and applications in the cloud</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrap section-padding-right" style={{ backgroundImage: 'url(' + methodologyimg + ')' }}>
                        </div>

                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li className="active">
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li>
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-2 bg-dark section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title"><span>02</span>Methodology</div>
                                <div className="text-wrapper">
                                    <div className="txt-main txt-big">
                                        <h5>Readiness Stage</h5>
                                        <p>For Vodafone Business Rapid Cloud Assessment, a readiness stage refers to the level
                                            or phase of preparedness that an organisation has reached in its journey towards
                                            moving to the cloud. Each stage represents a different level of maturity and
                                            progress, based on factors such as knowledge and experience of cloud technology,
                                            level of planning and preparation, and the extent to which they have begun the
                                            process of migrating to the cloud.
                                        </p>
                                        <p>By understanding and assessing the current stage of cloud readiness, organisations
                                            can better plan and execute their cloud migration strategy and optimise their cloud
                                            environment to support specitic business needs and goal.</p>
                                    </div>
                                    <div className="methodology-grid">
                                        <div className="meth-col beginner">
                                            <div className="item-wrapper">
                                                <div className="meth-title">Beginner</div>
                                                <div className="text-wrapper">Organisations in this stage may have little to no
                                                    experience with cloud technology and may have not conducted a comprehensive
                                                    assessment of their IT infrastructure. They may be uncertain about the
                                                    benefits of moving to the cloud or may be hesitant to make the necessary
                                                    changes to their IT environment. These organisations may need to invest
                                                    significant time and resources into developing a cloud strategy and
                                                    identifying the right cloud service provider for their needs.</div>
                                            </div>
                                        </div>
                                        <div className="meth-col intermediate">
                                            <div className="item-wrapper">
                                                <div className="meth-title">Intermediate</div>
                                                <div className="text-wrapper">Organisations in this stage may have conducted an
                                                    initial assessment ot their current infrastructure and identified some
                                                    applications or services that cloud be moved to the cloud. They may have
                                                    started the migration process for some workloads or applications but may
                                                    still be exploring the best cloud service provider for their needs. These
                                                    organisations may have some knowledge and experience with cloud technology
                                                    but may still be working to develop a comprehensive cloud strategy.</div>
                                            </div>
                                        </div>
                                        <div className="meth-col advanced">
                                            <div className="item-wrapper">
                                                <div className="meth-title">Advanced</div>
                                                <div className="text-wrapper">Organisations in this stage are well-prepared for the
                                                    cloud and may have already conducted a thorough assessment of their current
                                                    IT
                                                    infrastructure, have a clear understanding of their goals and objectives for
                                                    the cloud, and have identified the right cloud service provider for their
                                                    needs. They may have already begun the migration process and have a
                                                    well-defined plan in place for optimising their cloud environment.
                                                    These organisations may also have a strong culture of innovation and a
                                                    willingness to embrace new technologies to stay ahead of the curve.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrap section-padding-right" style={{ backgroundImage: 'url(' + methodologyimg2 + ')' }}>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li className="active">
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li>
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-3 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title"><span>03</span>[Enter Company] Cloud Assessment</div>
                                <div className="bold-text"><span>John Doe</span>, here’s your score based on your response to the
                                    lead indicators</div>
                                <div className="chart-wrapper">
                                    <img src={chart} />
                                </div>
                            </div>
                        </div>
                        <div className="progress-wrapper section-padding-right">
                            <div className="progress-heading">
                                <div className="heading-text">
                                    <p>Stage</p>
                                    <h3>Intermediate</h3>
                                </div>
                                <div className="percentage">59%</div>
                            </div>
                            <div className="progress-chart">
                                <div className="progress-list">
                                    <div className="icon-wrap">
                                        <img src={businessiconwhite} />
                                    </div>
                                    <div className="progress-wrap">
                                        <div className="heading ">
                                            <div className="pro-title">Business</div>
                                            <div className="value">72%</div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '72%' }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress-list">
                                    <div className="icon-wrap">
                                        <img src={peopleiconwhite} />
                                    </div>
                                    <div className="progress-wrap">
                                        <div className="heading ">
                                            <div className="pro-title">People</div>
                                            <div className="value">52%</div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '52%' }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress-list">
                                    <div className="icon-wrap">
                                        <img src={operatingmodeliconwhite} />
                                    </div>
                                    <div className="progress-wrap">
                                        <div className="heading ">
                                            <div className="pro-title">Operating Model</div>
                                            <div className="value">88%</div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '88%' }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress-list">
                                    <div className="icon-wrap">
                                        <img src={infraiconwhite} />
                                    </div>
                                    <div className="progress-wrap">
                                        <div className="heading ">
                                            <div className="pro-title">Infrastructure</div>
                                            <div className="value">60%</div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '60%' }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress-list">
                                    <div className="icon-wrap">
                                        <img src={networkiconwhite} />
                                    </div>
                                    <div className="progress-wrap">
                                        <div className="heading ">
                                            <div className="pro-title">Network</div>
                                            <div className="value">64%</div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '64%' }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress-list">
                                    <div className="icon-wrap">
                                        <img src={securityiconwhite} />
                                    </div>
                                    <div className="progress-wrap">
                                        <div className="heading ">
                                            <div className="pro-title">Security</div>
                                            <div className="value">20%</div>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '20%' }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li className="active">
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li>
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-3-inner section-3-1 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title">Business</div>
                                <div className="stat-data">
                                    Stage – <span className="bold">Intermediate</span> <span className="separator">|</span> Your score –
                                    <span className="bold">5%</span>
                                </div>
                                <div className="recommendations">
                                    <h4>Recommendations</h4>
                                    <ul>
                                        <li>Suscipit lobortis nisl ut aliquip ex ea commodo consequat</li>
                                        <li>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie
                                            consequat</li>
                                        <li>Vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan</li>
                                    </ul>
                                </div>
                                <div className="insights">
                                    <h4>Insight based on answers</h4>
                                    <div className="icon-text-list">
                                        <ul>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist1} />
                                                </div>
                                                <div className="text">
                                                    <h5>Recommendations based on answers</h5>
                                                    <p>Risus enim nec ornare odio pharetra augue mattis nibh nisi. Mi libero
                                                        mattis egestas ac tellus aliquam at. At sagittis id orci mattis dui in
                                                        nisl. Nisl vel augue diam in. Consequat pulvinar morbi diam amet
                                                        convallis faucibus volutpat amet dolor. Mi blandit cursus nibh.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist2} />
                                                </div>
                                                <div className="text">
                                                    <h5>Vodafone Business recommended services to improve indicator score....
                                                    </h5>
                                                    <p>Gravida senectus netus donec dictumst nec vitae. Neque ipsum cras lectus
                                                        donec sed duis sem tellus. Consectetur lacus libero id feugiat tempor.
                                                        Nisl enim suspendisse sit diam vitae elit. Luctus elementum laoreet
                                                        nullam lectus. Urna tellus ipsum nunc eu.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrapper section-padding-right" style={{ backgroundImage: 'url(' + businessimage + ')' }}>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li className="active">
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-3-inner section-3-1 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title">People</div>
                                <div className="stat-data">
                                    Stage – <span className="bold">Intermediate</span> <span className="separator">|</span> Your score –
                                    <span className="bold">5%</span>
                                </div>
                                <div className="recommendations">
                                    <h4>Recommendations</h4>
                                    <ul>
                                        <li>Suscipit lobortis nisl ut aliquip ex ea commodo consequat</li>
                                        <li>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie
                                            consequat</li>
                                        <li>Vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan</li>
                                    </ul>
                                </div>
                                <div className="insights">
                                    <h4>Insight based on answers</h4>
                                    <div className="icon-text-list">
                                        <ul>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist1} />
                                                </div>
                                                <div className="text">
                                                    <h5>Recommendations based on answers</h5>
                                                    <p>Risus enim nec ornare odio pharetra augue mattis nibh nisi. Mi libero
                                                        mattis egestas ac tellus aliquam at. At sagittis id orci mattis dui in
                                                        nisl. Nisl vel augue diam in. Consequat pulvinar morbi diam amet
                                                        convallis faucibus volutpat amet dolor. Mi blandit cursus nibh.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist2} />
                                                </div>
                                                <div className="text">
                                                    <h5>Vodafone Business recommended services to improve indicator score....
                                                    </h5>
                                                    <p>Gravida senectus netus donec dictumst nec vitae. Neque ipsum cras lectus
                                                        donec sed duis sem tellus. Consectetur lacus libero id feugiat tempor.
                                                        Nisl enim suspendisse sit diam vitae elit. Luctus elementum laoreet
                                                        nullam lectus. Urna tellus ipsum nunc eu.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrapper section-padding-right" style={{ backgroundImage: 'url(' + peopleimage + ')' }}>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li className="active">
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-3-inner section-3-1 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title">Operating Model</div>
                                <div className="stat-data">
                                    Stage – <span className="bold">Intermediate</span> <span className="separator">|</span> Your score –
                                    <span className="bold">5%</span>
                                </div>
                                <div className="recommendations">
                                    <h4>Recommendations</h4>
                                    <ul>
                                        <li>Suscipit lobortis nisl ut aliquip ex ea commodo consequat</li>
                                        <li>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie
                                            consequat</li>
                                        <li>Vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan</li>
                                    </ul>
                                </div>
                                <div className="insights">
                                    <h4>Insight based on answers</h4>
                                    <div className="icon-text-list">
                                        <ul>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist1} />
                                                </div>
                                                <div className="text">
                                                    <h5>Recommendations based on answers</h5>
                                                    <p>Risus enim nec ornare odio pharetra augue mattis nibh nisi. Mi libero
                                                        mattis egestas ac tellus aliquam at. At sagittis id orci mattis dui in
                                                        nisl. Nisl vel augue diam in. Consequat pulvinar morbi diam amet
                                                        convallis faucibus volutpat amet dolor. Mi blandit cursus nibh.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist2} />
                                                </div>
                                                <div className="text">
                                                    <h5>Vodafone Business recommended services to improve indicator score....
                                                    </h5>
                                                    <p>Gravida senectus netus donec dictumst nec vitae. Neque ipsum cras lectus
                                                        donec sed duis sem tellus. Consectetur lacus libero id feugiat tempor.
                                                        Nisl enim suspendisse sit diam vitae elit. Luctus elementum laoreet
                                                        nullam lectus. Urna tellus ipsum nunc eu.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="image-wrapper section-padding-right" style={{ backgroundImage: 'url(' + operatingmodelimage + ')' }}>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li className="active">
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-3-inner section-3-1 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title">Infrastructure</div>
                                <div className="stat-data">
                                    Stage – <span className="bold">Intermediate</span> <span className="separator">|</span> Your score –
                                    <span className="bold">5%</span>
                                </div>
                                <div className="recommendations">
                                    <h4>Recommendations</h4>
                                    <ul>
                                        <li>Suscipit lobortis nisl ut aliquip ex ea commodo consequat</li>
                                        <li>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie
                                            consequat</li>
                                        <li>Vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan</li>
                                    </ul>
                                </div>
                                <div className="insights">
                                    <h4>Insight based on answers</h4>
                                    <div className="icon-text-list">
                                        <ul>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist1} />
                                                </div>
                                                <div className="text">
                                                    <h5>Recommendations based on answers</h5>
                                                    <p>Risus enim nec ornare odio pharetra augue mattis nibh nisi. Mi libero
                                                        mattis egestas ac tellus aliquam at. At sagittis id orci mattis dui in
                                                        nisl. Nisl vel augue diam in. Consequat pulvinar morbi diam amet
                                                        convallis faucibus volutpat amet dolor. Mi blandit cursus nibh.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist2} />
                                                </div>
                                                <div className="text">
                                                    <h5>Vodafone Business recommended services to improve indicator score....
                                                    </h5>
                                                    <p>Gravida senectus netus donec dictumst nec vitae. Neque ipsum cras lectus
                                                        donec sed duis sem tellus. Consectetur lacus libero id feugiat tempor.
                                                        Nisl enim suspendisse sit diam vitae elit. Luctus elementum laoreet
                                                        nullam lectus. Urna tellus ipsum nunc eu.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrapper section-padding-right" style={{ backgroundImage: 'url(' + infraimage + ')' }}>

                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li className="active">
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-3-inner section-3-1 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title">Network</div>
                                <div className="stat-data">
                                    Stage – <span className="bold">Intermediate</span> <span className="separator">|</span> Your score –
                                    <span className="bold">5%</span>
                                </div>
                                <div className="recommendations">
                                    <h4>Recommendations</h4>
                                    <ul>
                                        <li>Suscipit lobortis nisl ut aliquip ex ea commodo consequat</li>
                                        <li>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie
                                            consequat</li>
                                        <li>Vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan</li>
                                    </ul>
                                </div>
                                <div className="insights">
                                    <h4>Insight based on answers</h4>
                                    <div className="icon-text-list">
                                        <ul>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist1} />
                                                </div>
                                                <div className="text">
                                                    <h5>Recommendations based on answers</h5>
                                                    <p>Risus enim nec ornare odio pharetra augue mattis nibh nisi. Mi libero
                                                        mattis egestas ac tellus aliquam at. At sagittis id orci mattis dui in
                                                        nisl. Nisl vel augue diam in. Consequat pulvinar morbi diam amet
                                                        convallis faucibus volutpat amet dolor. Mi blandit cursus nibh.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist2} />
                                                </div>
                                                <div className="text">
                                                    <h5>Vodafone Business recommended services to improve indicator score....
                                                    </h5>
                                                    <p>Gravida senectus netus donec dictumst nec vitae. Neque ipsum cras lectus
                                                        donec sed duis sem tellus. Consectetur lacus libero id feugiat tempor.
                                                        Nisl enim suspendisse sit diam vitae elit. Luctus elementum laoreet
                                                        nullam lectus. Urna tellus ipsum nunc eu.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrapper section-padding-right" style={{ backgroundImage: 'url(' + networkimage + ')' }}>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li className="active">
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-3-inner section-3-1 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title">Security</div>
                                <div className="stat-data">
                                    Stage – <span className="bold">Intermediate</span> <span className="separator">|</span> Your score –
                                    <span className="bold">5%</span>
                                </div>
                                <div className="recommendations">
                                    <h4>Recommendations</h4>
                                    <ul>
                                        <li>Suscipit lobortis nisl ut aliquip ex ea commodo consequat</li>
                                        <li>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie
                                            consequat</li>
                                        <li>Vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan</li>
                                    </ul>
                                </div>
                                <div className="insights">
                                    <h4>Insight based on answers</h4>
                                    <div className="icon-text-list">
                                        <ul>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist1} />
                                                </div>
                                                <div className="text">
                                                    <h5>Recommendations based on answers</h5>
                                                    <p>Risus enim nec ornare odio pharetra augue mattis nibh nisi. Mi libero
                                                        mattis egestas ac tellus aliquam at. At sagittis id orci mattis dui in
                                                        nisl. Nisl vel augue diam in. Consequat pulvinar morbi diam amet
                                                        convallis faucibus volutpat amet dolor. Mi blandit cursus nibh.</p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <img src={iconlist2} />
                                                </div>
                                                <div className="text">
                                                    <h5>Vodafone Business recommended services to improve indicator score....
                                                    </h5>
                                                    <p>Gravida senectus netus donec dictumst nec vitae. Neque ipsum cras lectus
                                                        donec sed duis sem tellus. Consectetur lacus libero id feugiat tempor.
                                                        Nisl enim suspendisse sit diam vitae elit. Luctus elementum laoreet
                                                        nullam lectus. Urna tellus ipsum nunc eu.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrapper section-padding-right" style={{ backgroundImage: 'url(' + securityimage + ')' }}>

                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li className="active">
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-4 section-height">
                    <div className="report-container">
                        <div className="content-wrapper">
                            <div className="text-wrap">
                                <div className="title"><span>04</span>Assessment questions</div>
                                <div className="qna-sections">
                                    <div className="qna-grid">
                                        <div className="qna-wrapper">
                                            <div className="qna-title">Business</div>
                                            <div className="question-answer-list">
                                                <div className="qna-inner">
                                                    <div className="question">Are you looking to move to the cloud due to external
                                                        factors? (i.e. Contract renewal, business move. business growth)</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">How far are you in creating a cloud strategy?</div>
                                                    <div className="answer">No strategy developed as yet</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Is your business looking to modernise the product
                                                        set/infrastructure when moving to the cloud? (i.e. moving from Virtual
                                                        Machines to Containers)</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">What factor is driving you to look into moving into
                                                        the cloud/3rd party provider?</div>
                                                    <div className="answer">End of contract with existing 3rd party provider</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Do you develop your own software/IT systems or is the
                                                        software from a 3rd party?</div>
                                                    <div className="answer">Yes (develop own)</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Do you have a clear business continuity or disaster
                                                        recovery plan that can be applied to the cloud ?</div>
                                                    <div className="answer">No plan currently</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="qna-grid">
                                        <div className="qna-wrapper">
                                            <div className="qna-title">People</div>
                                            <div className="question-answer-list">
                                                <div className="qna-inner">
                                                    <div className="question">Do you have the required knowledge to migrate the
                                                        services to the cloud?</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Do you have a training plan in place for a selected
                                                        cloud service or the ability to provide training?</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="qna-wrapper">
                                            <div className="qna-title">Infrastructure</div>
                                            <div className="question-answer-list">
                                                <div className="qna-inner">
                                                    <div className="question">Do you have any presence in the cloud currently?</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Are you aware of the benefits a cloud service provider
                                                        can bring to you business?</div>
                                                    <div className="answer">No investigations taken place</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Do you follow or adopt a DevOps methodology?</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Where is your current IT infrastructure located ?
                                                    </div>
                                                    <div className="answer">Own premises</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li>
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li className="active">
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={Redlogo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-4 section-height">
                    <div className="report-container">
                        <div className="content-wrapper">
                            <div className="text-wrap">
                                <div className="title"><span>04</span>Assessment questions</div>
                                <div className="qna-sections">
                                    <div className="qna-grid">
                                        <div className="qna-wrapper">
                                            <div className="qna-title">Operating Model</div>
                                            <div className="question-answer-list">
                                                <div className="qna-inner">
                                                    <div className="question">Does your business have any existing cloud knowledge?
                                                    </div>
                                                    <div className="answer">No knowledge to date</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Have you performed an internal review, have an
                                                        inventory list and created a cloud migration strategy?</div>
                                                    <div className="answer">No review as yet</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Can your business have any downtime or is there a 24/7
                                                        requirement for the IT services?</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Are you looking to move to the cloud, looking for a
                                                        3rd party provider to provide assistance or looking for a 3rd party to
                                                        provide full management?</div>
                                                    <div className="answer">Cloud</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Do you have a defined Cloud Operating Model ?</div>
                                                    <div className="answer">There is no Cloud Operating Model currently</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="qna-grid">
                                        <div className="qna-wrapper">
                                            <div className="qna-title">Network</div>
                                            <div className="question-answer-list">
                                                <div className="qna-inner">
                                                    <div className="question">Do you have a plan on how to connect environments to
                                                        the cloud?</div>
                                                    <div className="answer">No plans on how we would connect</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">What is the current connectivity method for your
                                                        business?</div>
                                                    <div className="answer">No connectivity</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="qna-wrapper">
                                            <div className="qna-title">Security</div>
                                            <div className="question-answer-list">
                                                <div className="qna-inner">
                                                    <div className="question">Have you developed or considered how a future
                                                        operation model will look like within the business?</div>
                                                    <div className="answer">No thoughts on how the operating model will change.
                                                    </div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Do you have experience of how to operate securely in
                                                        the cloud?</div>
                                                    <div className="answer">No Experience currently.</div>
                                                </div>
                                                <div className="qna-inner">
                                                    <div className="question">Have you identified specific Security or Compliance
                                                        requirements?</div>
                                                    <div className="answer">Yes</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li>
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li className="active">
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li>
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={Redlogo} />
                        </div>
                    </div>
                </div>
                <div className="content-main-section position-relative section-5 section-height">
                    <div className="content-wrapper">
                        <div className="text-wrap section-padding-left">
                            <div className="text-inner">
                                <div className="title"><span>05</span>Vodafone Business Cloud Services</div>
                                <div className="text-after-title">
                                    <div className="text-in">
                                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                                            euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
                                            minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                                            aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit.</p>
                                    </div>
                                    <div className="text-in">
                                        <h4>
                                            &lt; Enter Comany&gt; responses
                                        </h4>
                                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh
                                            euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad
                                            minim veniam, quis nostrud exerci tation.</p>
                                        <p>Ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem
                                            vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat. Duis
                                            autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat,
                                            vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio
                                            dignissim qui blandit praesent luptatum zzril delenit augue.</p>
                                    </div>
                                    <div className="text-in features">
                                        <h5>Features</h5>
                                        <ul className="features">
                                            <li>All assets can be connected to one central server</li>
                                            <li>Alert triggers based on analytics sent to user</li>
                                            <li>Integrated service with surveillance and analytics</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-wrapper section-padding-right" style={{ backgroundImage: 'url(' + vodafoneimage5 + ')' }}>
                        </div>
                    </div>
                    <div className="report-container position-abs-container">
                        <div className="page-counter">
                            <ul>
                                <li>
                                    <span className="count">01</span>
                                    <p>Introduction</p>
                                </li>
                                <li>
                                    <span className="count">02</span>
                                    <p>Methodology</p>
                                </li>
                                <li>
                                    <span className="count">03</span>
                                    <p>
                                        &lt; Enter Company&gt; Cloud Assessment
                                    </p>
                                </li>
                                <li>
                                    <span className="count">04</span>
                                    <p>Assessment questions</p>
                                </li>
                                <li className="active">
                                    <span className="count">05</span>
                                    <p>Vodafone Business Cloud Services</p>
                                </li>
                            </ul>
                        </div>
                        <div className="vodafone-logo">
                            <img src={logo} />
                        </div>
                    </div>
                </div>
                <div className="section-end section-height content-main-section">
                    <div className="report-container">
                        <div className="content-wrapper">
                            <img src={vodafonebusinesslogolast} />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
